<template>
  <Modal title="Ops! Algo deu errado" :is-open="isOpen" @close="emitClose">
    <template #default>
      <p>Não foi possível efetuar a sua solicitação de compra.</p>
      <p>Por favor, tente novamente mais tarde.</p>
    </template>
    <template #buttons>
      <ModalButton @click="emitClose">Ok</ModalButton>
    </template>
  </Modal>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

import { Modal, ModalButton } from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    Modal,
    ModalButton
  }
})
export default class OrderErrorModal extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly isOpen!: boolean;

  @Emit('close')
  public emitClose() {}
}
</script>
